import { PropsWithChildren, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { uiSetTranslationReady } from "Store/Actions";
import { selectIsTranslationReady, selectLanguage } from "Store/Selectors/UI";
import { Translator } from "Utils/Translator";
import { TranslationContext } from "./TranslationContext";

export function TranslationProvider(props: PropsWithChildren<unknown>): JSX.Element {
  const language = useSelector(selectLanguage);
  const isTranslationReady = useSelector(selectIsTranslationReady);
  const translator = useMemo(() => new Translator(language), [language]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isTranslationReady === false) {
      return;
    }
    dispatch(uiSetTranslationReady(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, language]);

  useEffect(() => {
    translator.initTranslator().then(() => {
      dispatch(uiSetTranslationReady(true));
    });
  }, [translator, dispatch]);

  if (!isTranslationReady) {
    // this is required to force react
    // to re-render all components
    return null;
  }

  const { children } = props;
  return <TranslationContext.Provider value={translator}>{children}</TranslationContext.Provider>;
}
